"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = exports.isDark = exports.rgbaAtCoords = void 0;
function rgbaAtCoords(x, y, imageData) {
    const redOffset = y * (imageData.width * 4) + x * 4;
    return [
        imageData.data[redOffset],
        imageData.data[redOffset + 1],
        imageData.data[redOffset + 2],
        imageData.data[redOffset + 3],
    ];
}
exports.rgbaAtCoords = rgbaAtCoords;
function isDark(x, y, imageData) {
    const [red, green, blue] = rgbaAtCoords(x, y, imageData);
    return red * 0.299 + green * 0.587 + blue * 0.114 > 186 ? false : true;
}
exports.isDark = isDark;
function range(start, end) {
    const arr = Array(end - start + 1);
    return arr.fill(0).map((_, i) => start + i);
}
exports.range = range;
//# sourceMappingURL=lightshow_utils.js.map